import type { WidgetConfigEntry } from '@agentselly/immodossier-shared';
import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

/**
 * Umbaumanager (House Remodelling Manager) is intentionally hidden from the
 * evaluation UI by default. The widget definition is kept here on purpose so it
 * stays available "in config" and can be re-enabled without a code change:
 * set VITE_ENABLE_HOUSE_REMODELLING_MANAGER=true in the environment.
 */
const ENABLE_HOUSE_REMODELLING_MANAGER =
  (import.meta as { env?: Record<string, string | undefined> }).env
    ?.VITE_ENABLE_HOUSE_REMODELLING_MANAGER === 'true';

const widgets: WidgetConfigEntry[] = [
  {
    name: 'evaluationDetailedEvaluation',
    cols: 6,
    rows: 3,
  },
  {
    name: 'evaluationScore',
    cols: 6,
    rows: 3,
  },
  {
    name: 'evaluationPropertyInformation',
    cols: 12,
    rows: 3,
  },
  {
    name: 'evaluationPropertyQuality',
    cols: 6,
    rows: 3,
  },
  {
    name: 'evaluationPropertyConditions',
    cols: 6,
    rows: 3,
  },
  {
    name: 'evaluationMyEnergyGuide',
    cols: 6,
    rows: 2,
  },
  {
    name: 'evaluationContact',
    cols: 6,
    rows: 2,
  },
  // Umbaumanager — only rendered when explicitly enabled via config flag.
  ...(ENABLE_HOUSE_REMODELLING_MANAGER
    ? [
        {
          name: 'evaluationHouseRemodellingManager',
          cols: 12,
          rows: 6,
        } as WidgetConfigEntry,
      ]
    : []),
];

export const evaluationWidgets = makeDynamicConfigWidgets(widgets);
